import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { PureComponent, Page, Serialize, Description } from 'core/components';
import { withAuth } from 'core/decorators';
import { Button, Popup } from 'core/components/Framework7';
import { CartProduct } from 'content/components';
import { deleteAllCartItem } from 'content/pages/Cart/Module';
import { ViewProfilePage } from 'content/pages';
import { getCart } from 'content/pages/Cart/Module';

import classes from './styles.module.css';

const Price = Serialize.Price

class Cart extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      cartDetailsSheetOpened: false,
      profileSheetOpened: false,
    }
  }

  componentDidMount() {
    if (this.props.reloadCart) {
      this.reloadCart()
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { authorized } = this.props;

    if (prevState.profileSheetOpened && authorized) {
      this.setState({
        profileSheetOpened: false,
      }, () => {
        this.setState({
          cartDetailsSheetOpened: true,
        })
      })
    }
  }

  get data() {
    const { env } = this.props;

    return {
      page: env && env.pages && env.pages.attention,
    }
  }

  reloadCart() {
    // console.log('reloading cart')
    this.$f7.dialog.preloader('در حال تبادل اطلاعات');

    this.props.getCart({ store: 2 })
      .finally(r => {
        this.$f7.dialog.close()
      })
  }

  setOrder() {
    // this.props.navigate.navigate('/step/address', { props: { navigate: this.props.navigate } })
    this.setState({
      cartDetailsSheetOpened: false
    })
  }

  login() {
    this.setState({
      cartDetailsSheetOpened: false,
      profileSheetOpened: true,
    }, () => {
      // this.props.navigate.navigate("/profile", { props: { navigate: this.props.navigate } })
      // console.log(this.$f7.views.profile)
      // this.$f7.views.profile.active()
    })
  }

  handleLoginClose() {
    const { authorized } = this.props;

    this.setState({
      cartDetailsSheetOpened: authorized,
      profileSheetOpened: false,
    })
  }

  deleteAllCartItem() {
    this.$f7.dialog.confirm("آیا از حذف همه آیتم ها اطمینان دارید؟", "حذف همه", this.confirmDelete)
  }

  confirmDelete() {
    this.props.deleteAllCartItem()
  }

  renderBtn() {
    const { env, authorized, cartPrice } = this.props

    if (env && env.store.closed) return this.renderStoreClosed()

    if (env && cartPrice && cartPrice.sumAfter < env.minimumOrderPrice) return this.renderMinimumOrder()

    if (!authorized) return this.renderRegisterFirst()

    return this.renderNext()
  }

  renderStoreClosed() {
    const { page } = this.data
    const storeClosed = (page && page.storeClosed) || ''

    return (
      <Button large fill
        className={`${classes.fullWidthButton} ${classes.buttonAttention}`}
      >
        <span>{storeClosed}</span>
      </Button>
    )
  }

  renderMinimumOrder() {
    const { env } = this.props;

    return (
      <Button large fill
        className={`${classes.fullWidthButton} ${classes.buttonAttention}`}
      >
        <span>{'حداقل خرید'}</span>
        <Price price={env.minimumOrderPrice} hasExtension={true} />
      </Button>
    )
  }

  renderRegisterFirst() {
    return (
      <Button large fill
        className={`${classes.fullWidthButton}`}
        icon="mdi-account"
        text={"لطفا وارد شوید"}
        onClick={this.login}
      />
    )
  }

  renderNext() {
    return (
      <Button large fill
        href="/step/address"
        view='#view-cart'
        className={`${classes.fullWidthButton}`}
        text={'مرحله بعد'}
        icon="mdi-arrow-left"
        onClick={this.setOrder}
      />
    )
  }

  render() {
    const { cartPrice, cart, navigate, order } = this.props;
    const price = cartPrice
    const giftValue = order && order.giftId && order.gift && order.gift.value || 0
    // console.log('Cart render props:', this.props)
    // console.log('items:', items)

    return (
      <React.Fragment>
        <div className={classes.container}>
          {cart.length > 0 && (
            <Button large raised
              icon="mdi-cart-remove"
              text={'حذف همه'}
              className={`${classes.fullWidthButton} button-top-full-width`}
              onClick={this.deleteAllCartItem}
            />
          )}

          <div className={`${classes.pagePadding}`}>
            <CartProduct
              items={cart}
            />
          </div>

          {cart.length > 0 &&
            <Button large fill
              icon="mdi-eye"
              text={'جزییات سفارش'}
              className={`${classes.fullWidthButton}`}
              onClick={() => { this.setState({ cartDetailsSheetOpened: true }) }}
            />
          }
        </div >

        <Popup
          id={'popup-payment-details'}
          closeByOutsideClick={false}
          swipeToClose
          opened={this.state.cartDetailsSheetOpened}
          onPopupClosed={() => { this.setState({ cartDetailsSheetOpened: false }) }}
        >
          <Page
            pageName='payment-details'
            title={'جزییات سفارش'}
            showBack={false}
            showClose={true}
            closePopup={true}
            closePopupClassName={'#popup-payment-details'}
            navigate={navigate}
          >
            <div className={classes.container}>
              <div className={`${classes.pagePadding}`}>
                <Description
                  sumBefore={price && price.sumBefore}
                  sumOfDiscounts={price && price.sumOfDiscounts}
                  sumAfter={price && price.sumAfter - giftValue}
                  gift={giftValue}
                />
              </div>

              {this.renderBtn()}
            </div>
          </Page>
        </Popup>

        <Popup
          id={'popup-profile-page'}
          closeByOutsideClick={false}
          swipeToClose
          opened={this.state.profileSheetOpened}
          onPopupClosed={this.handleLoginClose}
        >
          <ViewProfilePage
            showClose={true}
            popupClose={true}
            closePopupClassName={'#popup-profile-page'}
            view={'#view-cart'}
          />
        </Popup>
      </React.Fragment>
    )
  }
}

export default connect(
  state => ({
    env: state.General.env,
    authorized: state.General.authorized,
    cart: state.Cart.cart,
    cartPrice: state.Cart.price,
    order: state.Order.order,
  }),
  {
    getCart,
    deleteAllCartItem
  }
)(withAuth(autobind(Cart)));
